import { Span } from "@icg360/design-system";

import { useUser } from "data/ss-data-hooks";
import SettingsPanelLayout from "pages/settings/common/settings-panel-layout";

import ChangePassword from "./change-password";
import styles from "./security.module.scss";

const Security = () => {
  const user = useUser();
  return (
    <SettingsPanelLayout title="Security">
      {user && (
        <>
          <div className={styles.dataRow}>
            <Span bold>User ID:</Span>
            <Span>{user.email}</Span>
          </div>
          <div className={styles.dataRow}>
            <Span bold>Password:</Span>
            <Span className={styles.password}>
              <ChangePassword userId={user.userId} />
            </Span>
          </div>
        </>
      )}
    </SettingsPanelLayout>
  );
};

export default Security;
